import React from 'react'

import {Modal, S1, P, Colors, Button} from '../../../src/components/UI/index.js'
import {formSpacing} from '../../../src/components/UI/forms/index.js'

class ColliNotReadyPopup extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showPopup: false,
            colli: [],
            onStart: () => {},
            onClose: () => {}
        }
    }

    open(colli, onStart, onClose) {
        this.setState({
            showPopup: true,
            colli,
            onStart: typeof onStart === 'function' ? onStart : () => {},
            onClose: typeof onClose === 'function' ? onClose : () => {}
        })
    }

    render() {
        const {showPopup, colli, onClose, onStart} = this.state

        const defaultStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            background: Colors.backgroundNeutral,
            border: `1px solid ${Colors.border}`,
            borderRadius: 4,
            padding: 12,
            maxHeight: 'calc(100% - 48px)',
            display: 'flex',
            flexDirection: 'column'
        }

        return (
            <Modal
                show={showPopup}
                style={defaultStyle}
                onClose={() => {
                    this.setState({showPopup: false})
                    onClose()
                }}
                closeOnBackdropClick
            >
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <S1>
                        <i style={{color: Colors.errorBright, marginRight: 6}} className='mdi mdi-alert' />
                        Colli niet compleet
                    </S1>
                </div>
                <br />
                <P>Onderstaande colli zijn niet bevestigd. Ga terug om ze alsnog te bevestigen, of ga door om de route te starten zonder deze colli.</P>
                <br />
                <div style={{flex: 1, minHeight: 0, overflowY: 'auto'}}>
                    {colli.map((collo) => {
                        collo.address = collo.deliveryAddress || collo.pickupAddress

                        return (
                            <div key={collo.barcode} style={{marginBottom: 12}}>
                                <S1>{collo.address?.stopnumber && `${collo.address.stopnumber}.`} {collo.address.street}, {collo.address.postalCode} {collo.address.city}</S1>
                                <P>Collo {collo.index + 1}: {collo.barcode}</P>
                            </div>
                        )
                    })}
                </div>
                <div style={{marginTop: 12, display: 'flex', justifyContent: 'space-between', columnGap: formSpacing.columnGap}}>
                    <Button
                        onClick={() => {
                            this.setState({showPopup: false})
                            onClose()
                        }}
                        variant='text'
                        label='Terug'
                    />
                    <Button
                        onClick={() => {
                            this.setState({showPopup: false})
                            onStart(true)
                        }}
                        variant='text'
                        label='Start'
                    />
                </div>
            </Modal>
        )
    }
}

export default ColliNotReadyPopup
